import '@babel/polyfill'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import Loading from './directive/loading/index.js'
import './permission' // 权限

// 定义点击外部关闭下拉事件
Vue.directive('clickOut', {
  bind(el, binding, vnode) {
    document.addEventListener('click', e => {
      if (e.target === el || el.contains(e.target)) {
        return
      }
      binding.value()
    })
  }
})

Vue.use(iView)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.config.productionTip = false
new Vue({
  router,
  store,

  render: h => h(App)
}).$mount('#app')
